import { ReactNode, useState } from 'react';
import ImgCrop from 'antd-img-crop';
import { RcFile } from 'antd/es/upload';

import { Button, Image, Upload } from '~shared/ui';
import { CompressFile } from '~shared/lib/utils';
import defaultPhoto from '~shared/assets/defaultAvatar.svg';

const getBase64 = (img: RcFile, callback: any) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};

export interface ModalImageUploaderItem {
  url?: string;
  uploadText?: string;
  setFile?: any;
  onError?: ReactNode;
  label?: string;
  buttonText?: string;
  setUrl: (a: string) => void;
  bordered?: boolean;
}

export const ModalImageUploader: React.FC<ModalImageUploaderItem> = ({
  url = '',
  setFile,
  bordered = true,
  onError,
  label,
  buttonText,
  setUrl,
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  const isCurrentUrl = url && url.split('/')[url.split('/').length - 1] !== 'null';

  const successAvatar = (data: any) => {
    setLoading(false);
    setUrl(URL.createObjectURL(data));

    setFile(data);
  };

  const handleChange = (e: any) => {
    CompressFile(e.file.originFileObj, successAvatar);

    if (e.file.status === 'uploading') {
      setLoading(true);

      return;
    }

    if (e.file.status === 'done') {
      getBase64(e.file.originFileObj, (url: string) => {
        setLoading(false);
        setUrl(url);
      });
    }
  };

  return (
    <div
      className={`flex h-auto items-center gap-3 rounded-[16px] bg-white ${
        bordered ? 'p-3 hover:!border-primary' : ''
      }`}
      style={{
        border: bordered ? '1px solid var(--stroke)' : 'none',
      }}
    >
      <div className="w-[60px] h-[60px] bg-bg rounded-full flex items-center justify-center">
        <Image
          className="w-[60px] max-h-[60px] min-h-[60px] rounded-full overflow-hidden object-cover"
          src={url}
          fallback={defaultPhoto}
          preview={
            isCurrentUrl
              ? {
                  // visible: true,
                  maskClassName: '!rounded-full',
                  src: url.replace('sm', 'lg'),
                }
              : false
          }
        />
      </div>

      <div className="flex flex-col gap-2 justify-left">
        <p className="text-[12px] text-left leading-auto">{label}</p>

        <ImgCrop>
          <Upload onChange={handleChange} itemRender={() => <div />} className="flex justify-start">
            <Button size="small" type="primary" ghost loading={loading}>
              {buttonText}
            </Button>
          </Upload>
        </ImgCrop>
      </div>
    </div>
  );
};
